// src/Admin/notificationMeta.js
// Icon + color for each notification type, and "5 min ago" text.
// Shared by the bell and the full Notifications page.
import {
  faCalendarPlus,
  faRightToBracket,
  faUserClock,
  faKey,
  faUserPlus,
  faCalendarXmark,
  faClockRotateLeft,
  faPenToSquare,
  faCircleCheck,
  faArrowsRotate,
  faClock,
  faAward,
  faStar,
  faFire,
  faToggleOn,
  faToggleOff,
  faCalendarMinus,
  faCirclePause,
  faCircleStop,
  faCirclePlay,
  faBellConcierge,
  faGift,
  faTrophy,
  faFlagCheckered,
  faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';

export const TYPE_META = {
  demo_request: { icon: faCalendarPlus, tone: 'blue' },
  student_joined: { icon: faRightToBracket, tone: 'green' },
  teacher_joined: { icon: faRightToBracket, tone: 'green' },
  student_absent: { icon: faUserClock, tone: 'red' },
  teacher_absent: { icon: faUserClock, tone: 'red' },
  login: { icon: faKey, tone: 'muted' },
  // teacher dashboard
  demo_assigned: { icon: faCalendarPlus, tone: 'blue' },
  class_added: { icon: faCalendarPlus, tone: 'blue' },
  student_assigned: { icon: faUserPlus, tone: 'green' },
  class_rescheduled: { icon: faClockRotateLeft, tone: 'amber' },
  class_cancelled: { icon: faCalendarXmark, tone: 'red' },
  feedback_missing: { icon: faPenToSquare, tone: 'amber' },
  feedback_approved: { icon: faCircleCheck, tone: 'green' },
  student_paused: { icon: faCirclePause, tone: 'amber' },
  student_stopped: { icon: faCircleStop, tone: 'red' },
  student_resumed: { icon: faCirclePlay, tone: 'green' },
  // admin
  feedback_overdue: { icon: faPenToSquare, tone: 'amber' },
  renewal_needed: { icon: faArrowsRotate, tone: 'amber' },
  time_mismatch: { icon: faClock, tone: 'red' },
  certificates_needed: { icon: faAward, tone: 'blue' },
  parent_feedback: { icon: faStar, tone: 'amber' },
  enroll_interest: { icon: faFire, tone: 'red' },
  demos_on: { icon: faToggleOn, tone: 'green' },
  demos_off: { icon: faToggleOff, tone: 'amber' },
  no_demo_slots: { icon: faCalendarMinus, tone: 'red' },
  pause_ended: { icon: faBellConcierge, tone: 'amber' },
  referral_trial: { icon: faUserPlus, tone: 'blue' },
  referral_paid: { icon: faGift, tone: 'green' },
  competition_vote: { icon: faTrophy, tone: 'amber' },
  competition_join: { icon: faFlagCheckered, tone: 'blue' },
  competition_entry: { icon: faPaperPlane, tone: 'green' },
  competition_winners: { icon: faTrophy, tone: 'amber' },
  badge_earned: { icon: faAward, tone: 'amber' },
};

export const ago = (value) => {
  const d = value ? new Date(value) : null;
  if (!d || Number.isNaN(d.getTime())) return '';
  const min = Math.floor((Date.now() - d.getTime()) / 60000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min} min ago`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h}h ago`;
  const days = Math.floor(h / 24);
  if (days < 7) return `${days}d ago`;
  return d.toLocaleDateString('en-US', { timeZone: 'Asia/Beirut', month: 'short', day: 'numeric' });
};

